export default function initializeMaps() {

    var address = 'Zoetermeer, parelgrijs 4';
    var geocoder = new google.maps.Geocoder();

    var latlng = new google.maps.LatLng(52.1601144, 4.497009700000035);
    var drag = false;
    if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        drag = true;
    }

    var mapOptions = {
        featureType: "all",
        elementType: "labels",
        disableDoubleClickZoom: false,
        disableDefaultUI: false,
        scaleControl: true,
        panControl: false,
        navigationControl: true,
        mapTypeControl: false,
        zoomControlOptions: {
            position: google.maps.ControlPosition.RIGHT_TOP,
            style: google.maps.ZoomControlStyle.LARGE
        },
        mapTypeControlOptions: {
            mapTypeIds: [
                google.maps.MapTypeId.ROADMAP,
                google.maps.MapTypeId.HYBRID
            ],
            style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR
        },
        zoom: 15,
        center: latlng,
        scrollwheel: false,
        //panControl: true,
        //scaleControl: true,
        draggable: drag,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        styles: [{
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [{
                "visibility": "on"
            }, {
                "color": "#73b0c9"
            }]
        }, {
            "featureType": "landscape.natural",
            "stylers": [{
                "color": "#e3d5bf"
            }]
        }, {
            "featureType": "road",
            "stylers": [{
                "color": "#f8f0d9"
            }]
        }, {}]
    };


    var map = new google.maps.Map(
        document.getElementById('googleMaps'), mapOptions);
    
    // Call the codeAddress function (once) when the map is idle (ready)
    google.maps.event.addListenerOnce(map, 'idle', codeAddress);

    function codeAddress() {

        // Define address to center map to    

        geocoder.geocode({
            'address': address
        }, function (results, status) {

            if (status == google.maps.GeocoderStatus.OK) {

                // Center map on location
                map.setCenter(results[0].geometry.location);
                var center = results[0].geometry.location;

                //var infowindow = new google.maps.InfoWindow({
                //   content: 'AppStudio.nl'
                //});

                // Add marker on location
                var marker = new google.maps.Marker({
                    map: map,
                    icon: '../templates/1/res/svg/icons/icon_maps.svg',
                    position: results[0].geometry.location
                });

                // google.maps.event.addListener(marker, 'click', function() {
                //     infowindow.open(map, marker);
                // });

            } else {

                alert("Geocode was not successful for the following reason: " + status);
            }
        });
    }
}